function PageLink({ pageSize, pageNumber, label, onClick }) {
  return (
    <span
      className="page-link cursor-pointer"
      onClick={() => onClick(pageNumber, pageSize)}
    >
      {label}
    </span>
  );
}

function MoveToPreviousPage({ pageSize, pageNo, onClick }) {
  return (
    <li className={`page-item ${pageNo === 1 ? "disabled" : ""}`}>
      <PageLink
        pageSize={pageSize}
        pageNumber={pageNo - 1} // Go one page before the current page when clicked on <<
        label={"«"}
        onClick={onClick}
      ></PageLink>
    </li>
  );
}

function MoveToNextPage({ pageSize, pageNo, numberOfPages, onClick }) {
  return (
    <li className={`page-item ${pageNo === numberOfPages ? "disabled" : ""}`}>
      <PageLink
        pageSize={pageSize}
        pageNumber={pageNo + 1} // Go one page ahead of the current page when clicked on >>
        label={"»"}
        onClick={onClick}
      ></PageLink>
    </li>
  );
}

function Pages({ pageSize, pageNo, numberOfPages, onClick }) {
  const rows = [];

  const visibleRange = 1; // No of pages before & after the current page
  const startPage = Math.max(2, pageNo - visibleRange);
  const endPage = Math.min(numberOfPages - 1, pageNo + visibleRange);

  // Always show page 1
  rows.push(
    <li className={`page-item ${pageNo === 1 ? "active" : ""}`} key={1}>
      <PageLink
        pageSize={pageSize}
        pageNumber={1}
        label={1}
        onClick={onClick}
      />
    </li>
  );

  // Ellipsis before the middle section
  if (startPage > 2) {
    rows.push(
      <li className="page-item disabled" key="start-ellipsis">
        <span className="page-link">...</span>
      </li>
    );
  }

  // Pages around current page [middle section]
  for (let i = startPage; i <= endPage; i++) {
    rows.push(
      <li className={`page-item ${pageNo === i ? "active" : ""}`} key={i}>
        <PageLink
          pageSize={pageSize}
          pageNumber={i}
          label={i}
          onClick={onClick}
        />
      </li>
    );
  }

  // Ellipsis after the middle section
  if (endPage < numberOfPages - 1) {
    rows.push(
      <li className="page-item disabled" key="end-ellipsis">
        <span className="page-link">...</span>
      </li>
    );
  }

  // Always show last page if not already shown
  if (numberOfPages > 1) {
    rows.push(
      <li
        className={`page-item ${pageNo === numberOfPages ? "active" : ""}`}
        key={numberOfPages}
      >
        <PageLink
          pageSize={pageSize}
          pageNumber={numberOfPages}
          label={numberOfPages}
          onClick={onClick}
        />
      </li>
    );
  }
  return rows;
}

function Pagination({ totalCount, pageNo, pageSize, onClick, className = "" }) {
  const numberOfPages = Math.ceil(totalCount / pageSize);
  if (numberOfPages <= 1) {
    return null;
  }
  return (
    <div className={`pagination-cont clearfix ${className}`}>
      <ul className="pagination float-right">
        <MoveToPreviousPage
          pageSize={pageSize}
          pageNo={pageNo}
          onClick={onClick}
        />

        <Pages
          pageSize={pageSize}
          pageNo={pageNo}
          numberOfPages={numberOfPages}
          onClick={onClick}
        />

        <MoveToNextPage
          pageSize={pageSize}
          pageNo={pageNo}
          numberOfPages={numberOfPages}
          onClick={onClick}
        />
      </ul>
    </div>
  );
}

export default Pagination;
